module.exports = __webpack_public_path__ + "static/media/cafe_panorama.c213c9ed.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/features/RestaurantAndCafe/components/RestaurantAndCafe/images/cafe_panorama.jpg
// module id = 357
// module chunks = 0